import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const yourls = defineConnector({
  identifier: "yourls",
  name: "YOURLS",
  tagLine: "Self-hosted URL shortener",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ url }) =>
    url
      ? `${url.replace(/\./g, "\\.").replace(/\//g, "\\/")}/.*`
      : "https://.*",
  auth: (app) =>
    queryAuth([{ name: "signature", value: app.secret.signature }]),
  steps: [
    {
      title: "Get your signature token",
      items: [
        {
          kind: "markdown",
          content:
            "In your YOURLS admin panel, navigate to **Tools → Secure passwordless API call** to find your signature token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "baseUrl",
          label: "YOURLS URL",
          required: true,
          placeholder: "https://yourls.example.com",
          target: { kind: "configuration", field: "url" },
          helperText: "The base URL of your YOURLS instance.",
        },
        {
          kind: "input",
          label: "Signature",
          required: true,
          target: { kind: "secrets", field: "signature" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ url }) => `${url}/yourls-api.php?action=stats&format=json`,
  },
});
